module.exports = Object.freeze({
  1: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  2: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  3: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  4: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  5: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  6: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  7: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  8: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  9: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  10: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: `Symbolised as the 'Wheel of Fortune'. It is a number of honour, of faith and self-confidence, of rise and fall, one's name will be known for good or evil, according to one's desires , it is a fortunate number in the sense that one's plans are likely to be carried out`,
    compountHindi: `'व्हील ऑफ फॉर्च्यून' के प्रतीक के रूप में। यह कई सम्मान, विश्वास और आत्मविश्वास का उदय और पतन का है, किसी का नाम अच्छे या बुरे के लिए जाना जाएगा, किसी की इच्छाओं के अनुसार, यह इस अर्थ में एक भाग्यशाली संख्या है कि किसी की योजना को पूरा करने की संभावना है बाहर`,
    compoundMarathi: `'फॉर्च्यूनचे व्हील' म्हणून प्रतीकात्मक. हा एक सन्मान, विश्वास आणि आत्मविश्वास, उदय आणि गती यांचे एक नाव आहे, एखाद्याचे नाव चांगले किंवा वाईट म्हणून ओळखले जाईल, एखाद्याच्या इच्छेनुसार, ही योजना भाग्यवान आहे या अर्थाने ही एक भाग्यवान संख्या आहे. बाहेर`,
  },
  11: {
    result: `-`,
    stars: 4.0,
    percent: 90,
    combination: `Fortunes favourite`,
    compountNumbers: `This is an omimous number to occultists. It gives warning of hidden dangers, trial, and treachery from others. It has a symbol of "a Clenched Hand," and "a Lion Muzzled," and of a person who will have great difficulties to contend against`,
    compountHindi: `यह जादूगरों की एक बड़ी संख्या है। यह दूसरों से छिपे हुए खतरों, परीक्षण और विश्वासघात की चेतावनी देता है। इसमें "क्लेंक्ड हैंड," और "ए लायन मज्बल्ड" का प्रतीक है, और ऐसे व्यक्ति को, जिसके खिलाफ लड़ने में बड़ी मुश्किलें होंगी`,
    compoundMarathi: `जादूगारांना ही एक विपुल संख्या आहे. हे छुपे धोके, चाचणी आणि इतरांकडून विश्वासघात करण्याचा इशारा देते. यात "क्लेन्शेड हँड" आणि "शेर गोंधळलेले" चे प्रतीक आहे आणि ज्या व्यक्तीविरूद्ध संघर्ष करण्यास मोठ्या अडचणी असतील त्या व्यक्तीचे`,
  },
  12: {
    result: `OK`,
    stars: 4.0,
    percent: 70,
    combination: `Best for Navy (2 - Representing water, Moon)`,
    compountNumbers: `The symbolism of this number is suffering and anxiety of mind. It is also indicated sa "the Sacrifice” or "the Victim and generally foreshadows one being sacrificed for the plans or intrigues of others`,
    compountHindi: `इस संख्या का प्रतीक मन की पीड़ा और चिंता है। यह भी संकेत दिया गया है कि "सैक्रिफाइस" या "विक्टिम और आम तौर पर किसी की योजनाओं या साज़िशों के लिए बलिदान किया जा रहा है।`,
    compoundMarathi: `या संख्येचे प्रतीक म्हणजे दुःख आणि मनाची चिंता. "बळी" किंवा "बळी देणारा" देखील दर्शविला जातो आणि सामान्यत: एखाद्याच्या योजना किंवा इतरांच्या हेतूंसाठी बलिदान दिले जाण्याची शक्यता असते.`,
  },
  13: {
    result: `-`,
    stars: 3.5,
    percent: 70,
    combination: `Best for Occult, Teacher, Politician, Scientist, Law`,
    compountNumbers: `This is a number indicating change of plans, place, and such-like, and is not unfortunate, as is generally supposed. In some of the ancient writings it is said, "He who understands the number 13 will be given power and dominion". It is symbolised by the picture of "a Skeleton" or "Death,” with a scythe reaping down men, in a field of new-grown grass where young faces and heads appear cropping up on every side. It is a number of upheaval and destruction. It is a symbol of “Power” which if wrongly used will wreak destruction upon itself. It is a number of warning of the unknown or unexpected, if it becomes a "compound" number in one’s calculations`,
    compountHindi: `यह एक संख्या है जो योजनाओं, स्थान और इस तरह के परिवर्तन को दर्शाता है, और दुर्भाग्यपूर्ण नहीं है, जैसा कि आमतौर पर माना जाता है। कुछ प्राचीन लेखों में कहा गया है, "वह जो संख्या 13 को समझता है उसे शक्ति और प्रभुत्व दिया जाएगा"। यह "स्केलेटन" या "डेथ" की तस्वीर के प्रतीक के रूप में है, जो पुरुषों के नीचे एक नए सिरे से उगने वाली घास के मैदान में होती है, जहाँ युवा चेहरे और सिर हर तरफ फ़सते हुए दिखाई देते हैं। यह कई तरह की उथल-पुथल है। विनाश। यह "शक्ति" का प्रतीक है, जिसका अगर गलत तरीके से इस्तेमाल किया जाता है, तो यह विनाश को मिटा देगा। यह अज्ञात या अप्रत्याशित की चेतावनी का एक नंबर है, अगर यह किसी की गणना में "यौगिक" संख्या बन जाता है।`,
    compoundMarathi: `ही संख्या, योजना आणि अशा प्रकारचे बदल दर्शविणारी संख्या आहे आणि दुर्दैवी नाही, सामान्यत: मानल्याप्रमाणे. काही प्राचीन लेखनात असे म्हटले आहे की, "ज्याला 13 क्रमांक समजतो त्याला शक्ती व सत्ता दिली जाईल". हे "स्केलेटन" किंवा "मृत्यू" च्या चित्राने दर्शविले गेले आहे, ज्यात पुरुषांनी कापून काढले आहे, नवीन गवत असलेल्या शेतात जेथे तरुण चेहरे आणि डोके सर्व बाजूंनी कापताना दिसतात. हे असंख्य उलथापालथ आहे आणि विनाश. हे "पॉवर" चे प्रतीक आहे जे चुकीच्या पद्धतीने वापरले तर स्वतःच विनाश ओढवेल. एखाद्याच्या गणनेमध्ये ती "कंपाऊंड" संख्या बनल्यास ती अज्ञात किंवा अनपेक्षित चेतावणी देणारी संख्या आहे`,
  },
  14: {
    result: `Very Good`,
    stars: 3.0,
    percent: 80,
    combination: `Politics (1—Sun {King} & 4 - Rahu}, consultant, drinker, Publication, export-import, machine work`,
    compountNumbers: `This is a number of movement, combination of people and things, and danger from natural forces, such as tempests, water, air, or fire. This number is fortunate for dealings with money, speculation, and changes in business, but there is always a strong element of risk and danger attached to it, but generally owing to the actions and foolhardiness of others. If this number comes out in calculations of future events the person should be warned to act with caution and prudence`,
    compountHindi: `यह कई तरह के आंदोलन, लोगों और चीजों के संयोजन, और प्राकृतिक बलों, जैसे कि टेम्परेचर, पानी, हवा या आग से होने वाला खतरा है। यह संख्या पैसे, सट्टेबाजी और व्यापार में परिवर्तन के साथ व्यवहार करने के लिए भाग्यशाली है, लेकिन इसमें जोखिम और खतरे का एक मजबूत तत्व हमेशा जुड़ा हुआ है, लेकिन आम तौर पर दूसरों के कार्यों और मूर्खता के कारण। यदि यह संख्या भविष्य की घटनाओं की गणना में सामने आती है, तो व्यक्ति को सावधानी और विवेक के साथ कार्य करने की चेतावनी दी जानी चाहिए`,
    compoundMarathi: `ही असंख्य हालचाल, लोक आणि वस्तूंचे संयोजन आणि नैसर्गिक शक्तींचा धोका, जसे की मोह, पाणी, हवा किंवा आग. ही संख्या पैसे, सट्टेबाजी आणि व्यवसायातील बदलांसाठी भाग्यवान आहे, परंतु त्यामध्ये नेहमीच जोखीम आणि धोक्याचे एक मजबूत घटक जोडलेले असते परंतु सामान्यत: इतरांच्या कृती आणि मूर्खपणामुळे. ही संख्या भविष्यातील कार्यक्रमांच्या मोजणीत बाहेर आल्यास त्या व्यक्तीस सावधगिरीने आणि विवेकीपणाने वागण्याचा इशारा दिला पाहिजे`,
  },
  15: {
    result: `Excellent`,
    stars: 4.0,
    percent: 80,
    combination: `Banking & Finance, commission, consultant, Fire, hotel`,
    compountNumbers: `This is a number of occult significance, of magic and mystery, but as a rule it does not represent the higher side of occultism, its meaning being that the persons represented by it will use every art of magic they can to carry out their purpose. If associated with a good or fortunate single number, it can be very lucky and powerful, but if associated with one of the peculiar numbers, such as a 4 or an 8, the person it represents will not scruple to use any sort of art, or even "black magic," to gain what he or she desires. It is peculiarly associated with "good talkers,” often with eloquence, gifts of Music and Art and a dramatic personality, combined with a certain voluptuous temperament and strong personal magnetism. For obtaining money, gifts, and favours from others it is a fortunate number`,
    compountHindi: `यह जादू और रहस्य के कई मनोगत महत्व है, लेकिन एक नियम के रूप में यह भोगवाद के उच्च पक्ष का प्रतिनिधित्व नहीं करता है, इसका अर्थ यह है कि इसका प्रतिनिधित्व करने वाले व्यक्ति जादू की हर कला का उपयोग करेंगे जो वे अपने उद्देश्य को पूरा करने के लिए कर सकते हैं। यदि एक अच्छी या भाग्यशाली एकल संख्या के साथ जुड़ा हुआ है, तो यह बहुत भाग्यशाली और शक्तिशाली हो सकता है, लेकिन यदि एक अजीब संख्या के साथ जुड़ा हुआ है, जैसे कि 4 या 8, तो वह जिस व्यक्ति का प्रतिनिधित्व करता है वह किसी भी प्रकार की कला का उपयोग करने के लिए हाथ नहीं करेगा। या यहां तक कि "काला जादू", जो वह चाहता है या प्राप्त करने के लिए। यह अजीब तरह से "अच्छे बात करने वालों" के साथ जुड़ा हुआ है, अक्सर वाक्पटुता के साथ, संगीत और कला के उपहार और एक नाटकीय व्यक्तित्व, एक निश्चित अस्थिर स्वभाव और मजबूत व्यक्तिगत चुंबकत्व के साथ जोड़ा जाता है। दूसरों के लिए धन, उपहार और एहसान प्राप्त करने के लिए यह एक भाग्यशाली संख्या है।`,
    compoundMarathi: `हे जादू आणि गूढपणाचे अनेक गूढ महत्त्व आहे, परंतु नियम म्हणून ते भूतविद्याच्या उच्च बाजूचे प्रतिनिधित्व करीत नाही, याचा अर्थ असा आहे की त्याद्वारे प्रतिनिधित्व केलेले व्यक्ती त्यांच्या हेतूची पूर्तता करण्यासाठी त्यांच्या जादूची प्रत्येक कला वापरतील. जर एखाद्या चांगल्या किंवा भाग्यवान एकल संख्येशी संबंधित असेल तर ते खूप भाग्यवान आणि सामर्थ्यवान असू शकते, परंतु जर 4 किंवा 8 यासारख्या विचित्र क्रमांकाशी संबंधित असेल तर, तो ज्या व्यक्तीचे प्रतिनिधित्व करतो तो कोणत्याही प्रकारची कला वापरण्यास विफल होणार नाही, किंवा अगदी "काळी जादू" देखील तिला किंवा तिला पाहिजे असलेल्या गोष्टी मिळवण्यासाठी. हा विशिष्ट शब्द "चांगल्या बोलणा with्यांशी" संबंधित असतो, बहुतेक वेळेस वाक्प्रचार, संगीत आणि कला आणि एक नाट्यमय व्यक्तिमत्त्व असते ज्यात विशिष्ट स्वभाव आणि मजबूत वैयक्तिक चुंबकीयता असते. पैसे, भेटवस्तू आणि इतरांच्या पसंती मिळविण्याकरिता ही भाग्यवान संख्या असते.`,
  },
  16: {
    result: `Can Go`,
    stars: 3.5,
    percent: 80,
    combination: `Luxury / Glamour, Eating joints`,
    compountNumbers: `This number has a most peculiar occult symbolism. It is pictured by "a Tower Struck by Lightning from which a man is falling with a Crown on his head", It is also called "the Shattered Citadel. It gives warning of some strange fatality awaiting one, also danger of accidents and defeat of one’s plans. If it appears as a "compound" number relating to the future, it is a warning sign that should be carefully noted and plans made in advance in the endeavour to avert its fatalistic tendency`,
    compountHindi: `इस संख्या में एक अजीबोगरीब मनोगत प्रतीक है। यह "एक टॉवर स्ट्रक द्वारा लाइटनिंग द्वारा चित्रित किया गया है जिसमें से एक आदमी अपने सिर पर एक क्राउन के साथ गिर रहा है", इसे "बिखर सिटाडेल" भी कहा जाता है। यह कुछ अजीब घातक घटनाओं की प्रतीक्षा कर रहा है, दुर्घटनाओं और हार का खतरा भी देता है। किसी की योजना। यदि यह भविष्य से संबंधित "यौगिक" संख्या के रूप में प्रकट होता है, तो यह एक चेतावनी संकेत है जिसे सावधानी से नोट किया जाना चाहिए और इसके घातक प्रवृत्ति को रोकने के प्रयास में अग्रिम रूप से बनाई गई योजनाएं`,
    compoundMarathi: `या संख्येत सर्वात विलक्षण जादूचे प्रतीक आहे. "टॉवर स्ट्रॉक बाय लाइटनिंग" असे चित्रित केले आहे ज्यावरून एक माणूस डोक्यावर मुकुट घसरत आहे, असे म्हणतात, "शॅटरड गड" असे म्हटले जाते. एखाद्याच्या प्रतीक्षेत काही विचित्र प्राणघातकतेचा इशारा देतो, अपघात होण्याची भीती आणि पराभवाचा धोका. एखाद्याची योजना. भविष्यात संबंधित "कंपाऊंड" संख्या म्हणून ती दिसली तर ती एक चेतावणी चिन्ह आहे ज्याची काळजीपूर्वक नोंद घ्यावी आणि त्याच्या जीवघेण्या प्रवृत्तीला रोखण्यासाठी प्रयत्नात असलेल्या आगाऊ योजना.`,
  },
  17: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Best for Occult / Education / Research / Chemicals, Electrical. Medicines`,
    compountNumbers: `This is a highly spiritual number, and is expressed in symbolism by the 8-pointed Star of Venus' a symbol of "Peace and Love". It is also called "the Star of the Magi" and expresses that the person it represents has risen superior in spirit to the trials and difficulties of his life or his career. It is considered a "number of immortality” and that the person’s name "lives after him”. It is a fortunate number if it works out in relation to future events, provided it is not associated with the single numbers of fours and eights`,
    compountHindi: `यह एक उच्च आध्यात्मिक संख्या है, और 8-स्टार ऑफ़ वीनस के प्रतीक द्वारा "शांति और प्रेम" का प्रतीक है। इसे "मागी का सितारा" भी कहा जाता है और यह व्यक्त करता है कि जिस व्यक्ति का प्रतिनिधित्व करता है वह अपने जीवन या अपने कैरियर की कठिनाइयों और कठिनाइयों के लिए आत्मा में श्रेष्ठ है। इसे "अमरता की संख्या" माना जाता है और व्यक्ति का नाम "उसके बाद रहता है"। यह भविष्य की घटनाओं के संबंध में काम करने पर एक सौभाग्यशाली संख्या है, बशर्ते वह चार और आठ की एकल संख्या से संबद्ध न हो`,
    compoundMarathi: `ही एक अत्यंत आध्यात्मिक संख्या आहे आणि व्हीनसच्या--सूत्रीय ताराने "शांती आणि प्रेम" यांचे प्रतीक म्हणून ती व्यक्त केली आहे. त्याला "स्टार ऑफ द मॅगी" देखील म्हटले जाते आणि व्यक्त करते की ती व्यक्ती प्रतिनिधित्व करते ती आयुष्यातल्या किंवा त्याच्या कारकिर्दीतील परीक्षांमुळे किंवा परीक्षांपेक्षा आत्म्याने श्रेष्ठ झाला आहे. हे एक "अमरत्व संख्या" मानले जाते आणि त्या व्यक्तीचे नाव "त्याच्या नंतर जगतो". भविष्यातील घटनांच्या संदर्भात कार्य केल्यास ते भाग्यवान आहे, जर ते चौकार आणि ईटच्या एकाच संख्येशी संबंधित नसेल तर`,
  },
  18: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: `Struggle / Marriage ? / Iron, Transport, commission agent`,
    compountNumbers: `This number has a difficult symbolism to translate. It is pictured as "a rayed moon from which drops of blood are falling, a wolf and a hungry dog are seen below catching the falling drops of blood in their opened mouths, while still lower a crab is seen hastening to join then". It is symbolic of materialism striving to destroy the spiritual side of the nature. It generally associates a person with bitter quarrels, even family ones, also with war, social upheavals, revolutions, and in some cases it indicates making money and position through wars or by wars. It is, however, a warning of treachery, deception by others, also danger from the elements, such as storms, danger from water, fires and explosions. When this "compound" number appears in working out dates in advance, such a date should be taken with a great amount of care, caution, and circumspection`,
    compountHindi: `इस संख्या का अनुवाद करने के लिए एक कठिन प्रतीकवाद है। इसे "एक किरणित चंद्रमा के रूप में चित्रित किया गया है जिसमें से रक्त की बूंदें गिर रही हैं, एक भेड़िया और एक भूखा कुत्ता अपने खुले हुए मुंह में खून की गिरती हुई बूंदों को पकड़ते हुए नीचे देखा जाता है, जबकि अभी भी एक केकड़ा तब जुड़ने के लिए जल्दबाजी करता है"। यह प्रकृति के आध्यात्मिक पक्ष को नष्ट करने के प्रयास भौतिकवाद का प्रतीक है। यह आम तौर पर एक व्यक्ति को कड़वे झगड़े, यहां तक कि परिवार वाले, युद्ध, सामाजिक उथल-पुथल, क्रांतियों के साथ भी जोड़ता है, और कुछ मामलों में यह युद्ध के माध्यम से या युद्धों के माध्यम से पैसा और स्थिति बनाने का संकेत देता है। हालांकि, यह विश्वासघात की चेतावनी है, दूसरों द्वारा धोखे, तत्वों से भी खतरा है, जैसे कि तूफान, पानी से खतरा, आग और विस्फोट। जब यह "मिश्रित" संख्या अग्रिम में तारीखों को काम करने में प्रकट होती है, तो इस तरह की तारीख को सावधानीपूर्वक सावधानी और सावधानी से परिमाण के साथ लिया जाना चाहिए।`,
    compoundMarathi: `या संख्येत भाषांतर करणे कठीण आहे. असे चित्रित केले आहे की, “एक किरण चंद्र, ज्यामधून रक्ताचे थेंब पडत आहेत, खाली एक लांडगा आणि भुकेलेला कुत्रा त्यांच्या उघड्या तोंडात रक्ताचे थेंब पकडताना खाली दिसला आहे, तर एक खेकडा कमी झाल्यावर त्यामध्ये सामील होण्यास घाई होते." हे निसर्गाची आध्यात्मिक बाजू नष्ट करण्याचा प्रयत्न करीत भौतिकवाद प्रतिकात्मक आहे. हे सामान्यत: एखाद्या व्यक्तीला कडवट झगडे, अगदी कुटूंबातही, युद्ध, सामाजिक उलथापालथ, क्रांतिकारणासह जोडते आणि काही प्रकरणांमध्ये हे युद्धांतून किंवा युद्धांतून पैसे आणि स्थान मिळवण्याचे संकेत देते. तथापि, हा विश्वासघात, इतरांच्या फसवणूकीचा इशारा आहे, वादळ, पाण्यापासून होणारा धोका, आग आणि स्फोट यासारख्या घटकांकडून देखील धोका. जेव्हा या "कंपाऊंड" क्रमांकाची तारीख अगोदरच्या कामकाजामध्ये दिसून येते तेव्हा अशी तारीख काळजीपूर्वक, सावधगिरीने आणि प्रसंगी घेतली पाहिजे`,
  },
  19: {
    result: `Excellent`,
    stars: 5.0,
    percent: 100,
    combination: `Super successful / metal, electricity, computer, architecture`,
    compountNumbers: `This number is regarded as fortunate and extremely favourable. It is symbolised as “the Sun" and is called the Prince of Heaven". It is a number promising happiness, success, esteem and honour, and promises success in one's plans for the future`,
    compountHindi: `यह संख्या भाग्यशाली और अत्यंत अनुकूल मानी जाती है। इसे "सूर्य" का प्रतीक माना जाता है और इसे स्वर्ग का राजकुमार कहा जाता है। यह एक आशाजनक खुशी, सफलता, सम्मान और सम्मान है, और भविष्य के लिए किसी की योजना में सफलता का वादा करता है`,
    compoundMarathi: `ही संख्या भाग्यवान आणि अत्यंत अनुकूल मानली जाते. हे "सूर्य" म्हणून प्रतीक आहे आणि त्याला स्वर्गाचा प्रिन्स म्हणतात. आनंद, यश, सन्मान आणि सन्मान देणारी ही एक संख्या आहे आणि भविष्यातील एखाद्याच्या योजनांमध्ये यशाची ग्वाही देते`,
  },
  20: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: `This number is called “the Awakening"; also “the Judgment”. It is symbolised by the figure of a winged angel sounding a trumpet, while from below a man, a woman, and a child are seen nsmg from a tomb with their hands clasped in prayer. This number has a peculiar interpretation the awakening of new purpose, new plans, new ambitions, the call to action, but for some great purpose, cause or duty. It is not a material number and consequently is a doubtful one as far as worldly success is concerned. If used m relation to a future event, it denotes delays, hindrances to one’s plans, which can only be conquered through the development of the spiritual side of the nature`,
    compountHindi: `यह संख्या "जागृति" कहलाती है, "निर्णय" भी। इसका प्रतीक एक पंखों वाले स्वर्गदूत के चित्र से है, जो एक तुरही की आवाज़ करता है, जबकि नीचे एक आदमी, एक महिला और एक बच्चे को हाथों से एक कब्र से nsmg दिखाई देता है। प्रार्थना में लगा हुआ। इस संख्या की एक नई व्याख्या, नए उद्देश्य, नई योजनाएं, नई महत्वाकांक्षाएं, कार्रवाई का आह्वान, लेकिन किसी महान उद्देश्य, कारण या कर्तव्य के जागरण की एक अजीब व्याख्या है। यह कोई भौतिक संख्या नहीं है और परिणामस्वरूप यह एक संदिग्ध भी है। जहाँ तक सांसारिक सफलता का सवाल है। यदि किसी भविष्य की घटना के संबंध में m का उपयोग किया जाता है, तो यह देरी को दर्शाता है, किसी की योजनाओं में बाधा उत्पन्न करता है, जिसे केवल प्रकृति के आध्यात्मिक पक्ष के विकास के माध्यम से ही प्राप्त किया जा सकता है।`,
    compoundMarathi: `या नंबरला "जागरण" असे म्हणतात, "न्यायाधीश" देखील म्हणतात. पंख असलेल्या देवदूताने कर्णे वाजविला होता तेव्हा त्या मूर्तीची प्रतीक्षा केली जाते, तर खाली पुरुष, एक स्त्री आणि मूल त्यांच्या हातांनी थडग्यातून एनएसएमजी पाहिले आहे. या आकड्यात नवीन हेतू, नवीन योजना, नवीन महत्वाकांक्षा, कृती करण्याची विनंती, पण काही महान हेतू, कारण किंवा कर्तव्याची जागरण हे एक विचित्र अर्थ आहे. ही एक भौतिक संख्या नाही आणि परिणामी संशयास्पद आहे जोपर्यंत सांसारिक यशाचा संबंध आहे. जर मी भविष्यातील घटनेशी संबंधित असेल तर तो विलंब म्हणजे एखाद्याच्या योजनांमध्ये अडथळा दर्शवितो, जो केवळ निसर्गाच्या अध्यात्मिक बाजूच्या विकासाद्वारेच जिंकला जाऊ शकतो.`,
  },
  21: {
    result: `OK`,
    stars: 3.5,
    percent: 70,
    combination: `Successful / water, writer, chemical, sea, Arts, acting`,
    compountNumbers: `This number is symbolised by the picture of “the Universe," and it is also called “the Crown of the Magi". It is a number of advancement, honours, elevation in life, and general success. It means victory after a long fight, for “the Crown of the Magi” is only gained after long initiation and tests of determmation. It is a fortunate number of promise if it appears in any connection with future events`,
    compountHindi: `यह संख्या "ब्रह्माण्ड" की तस्वीर का प्रतीक है और इसे "द क्राउन ऑफ द मागी" भी कहा जाता है। यह उन्नति, सम्मान, जीवन में उन्नति, और सामान्य सफलता है। इसका मतलब है कि लंबी लड़ाई के बाद जीत, "मागी का मुकुट" केवल लंबी दीक्षा और दृढ़ संकल्प के परीक्षणों के बाद प्राप्त की जाती है। यह भविष्य की घटनाओं के साथ किसी भी संबंध में प्रकट होने पर यह एक भाग्यशाली संख्या है`,
    compoundMarathi: `"ब्रह्मांड" च्या चित्राने ही संख्या दर्शविली आहे आणि त्याला "मॅगीचे मुकुट" देखील म्हटले जाते. हे असंख्य प्रगती, सन्मान, जीवनात उन्नती आणि सामान्य यश आहे. याचा अर्थ असा आहे की दीर्घ संघर्षानंतर विजय मिळवा, कारण “मॅगीचा मुकुट” केवळ दीक्षा घेतल्यानंतर आणि निवारणाच्या चाचणीनंतरच मिळविला जातो. भविष्यातील घटनांशी संबंधित असल्यास ती आश्वासनांची भाग्यवान संख्या आहे`,
  },
  22: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Flickering Mind, Best for water related work / Navy / Sweets / Cold drink/ Intuition power good, dairy`,
    compountNumbers: `This number is symbolised by “a Good Man blinded by the folly of others, with a knapsack on his back full of Errors". In this picture he appears to offer no defence against a fercious tiger which is attacking him. It is a warning number of illusion and delusion, a good person who lives in a fool's paradise, a dreamer of dreams who awakens only when surrounded by danger. It is also a number of false judgment owing to the influence of others. As a number in connection with future events its warning and meaning should be carefully noted`,
    compountHindi: `इस संख्या को "दूसरों की मूर्खता से अंधा एक अच्छा आदमी द्वारा प्रतीकित किया जाता है, उसकी पीठ पर इरर्स से भरा एक चाकू होता है" इस तस्वीर में वह एक क्रूर बाघ के खिलाफ कोई बचाव पेश नहीं करता है जो उस पर हमला कर रहा है। यह एक चेतावनी संख्या है। भ्रम और भ्रम, एक अच्छा व्यक्ति जो मूर्ख के स्वर्ग में रहता है, सपने देखने वाला व्यक्ति जो खतरे से घिरा होने पर ही जागता है। यह दूसरों के प्रभाव के कारण कई झूठे फैसले हैं। भविष्य की घटनाओं के संबंध में एक संख्या के रूप में। इसकी चेतावनी और अर्थ को ध्यान से देखा जाना चाहिए`,
    compoundMarathi: `या संख्येचे प्रतीक “इतरांच्या मुर्खपणामुळे अंध झालेला माणूस आणि त्याच्या पाठीवर चुकांमुळे भरलेला हल्ला” असे चित्रित केले आहे. या चित्रात तो एखाद्या सभ्य वाघावर हल्ला करीत असल्याचा प्रतिकार करीत नाही असे दिसते. ही चेतावणी संख्या आहे भ्रम आणि भ्रम, मूर्ख व्यक्तीच्या स्वर्गात राहणारी चांगली व्यक्ती, स्वप्नांचा स्वप्न पाहणारा जो जेव्हा धोक्याभोवती जागृत होतो तेव्हाच तो इतरांच्या प्रभावामुळे खोट्या निर्णयाचा आहे. भविष्यातील घटनांशी संबंधित एक संख्या त्याचा इशारा आणि अर्थ काळजीपूर्वक लक्षात घेतला पाहिजे`,
  },
  23: {
    result: `Very Good`,
    stars: 2.5,
    percent: 50,
    combination: `Occult education / Healer / Teacher, medicines, agriculture, Finance`,
    compountNumbers: `This number is called “the Royal Star of the Lion". It is a promise of success, help from superiors and protection from those in high places. In dealing with future events it is a most fortunate number and a promise of success for one’s plans`,
    compountHindi: `इस नंबर को "द लायन का शाही सितारा" कहा जाता है। यह सफलता का एक वादा है, उच्च स्थानों से वरिष्ठों और सुरक्षा में मदद करता है। भविष्य की घटनाओं से निपटने के लिए यह सबसे भाग्यशाली संख्या है और किसी की योजनाओं के लिए सफलता का एक लक्ष्य है।`,
    compoundMarathi: `या क्रमांकास “सिंहाचा रॉयल स्टार” म्हणतात. ही यशाची प्रतिज्ञा आहे, वरिष्ठांकडून मदत मिळेल आणि उच्च स्थानावरील लोकांकडून संरक्षण मिळेल. भविष्यातील घटनांचा सामना करताना ही एक भाग्यवान संख्या आहे आणि एखाद्याच्या योजनांसाठी यशाचा एक अंदाज आहे.`,
  },
  24: {
    result: `Avoid`,
    stars: 1.5,
    percent: 30,
    combination: `Struggle / Depression / Film maker, Computer, Liquid, computer, books`,
    compountNumbers: `This number is also fortunate; it promises the assistance and association of those of rank and position with one’s plans, it also denotes gain through love and the opposite sex, it is a favourable number when it comes out in relation to future events`,
    compountHindi: `यह संख्या भी सौभाग्यशाली है; यह एक योजना के साथ रैंक और स्थिति वाले लोगों की सहायता और सहयोग का वादा करता है, यह प्रेम और विपरीत लिंग के माध्यम से लाभ को भी दर्शाता है, भविष्य की घटनाओं के संबंध में यह एक अनुकूल संख्या है।`,
    compoundMarathi: `ही संख्या देखील भाग्यवान आहे; हे एखाद्याच्या योजनांसह पद आणि स्थान असलेल्यांच्या सहकार्याची आणि संबद्धतेची प्रतिज्ञा करते, हे प्रेम आणि उलट लैंगिकतेद्वारे मिळवलेले अर्थ देखील दर्शवते, जेव्हा भविष्यातील घटनांच्या संबंधात ही एक चांगली संख्या असते तेव्हा`,
  },
  25: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Best for Property / Real state / Finance M.B.A / Banking / stock market, advertisment`,
    compountNumbers: `This is a number denoting strength gained through experience, and benefits obtained through observation of people and things. It is not deemed exactly “lucky,” as its success is given through strife and trials in the earlier life. It is favourable when it appears in regard to the future`,
    compountHindi: `यह एक संख्या है जो अनुभव के माध्यम से प्राप्त ताकत है, और लोगों और चीजों के अवलोकन के माध्यम से प्राप्त लाभ। यह वास्तव में "भाग्यशाली" नहीं माना जाता है, क्योंकि इसकी सफलता पहले के जीवन में संघर्ष और परीक्षणों के माध्यम से दी गई है। भविष्य के संबंध में प्रकट होने पर यह अनुकूल है`,
    compoundMarathi: `अनुभवाद्वारे मिळविलेली ही संख्या आणि लोक आणि गोष्टींच्या निरीक्षणाद्वारे मिळविलेले फायदे दर्शविणारी ही संख्या आहे. हे यशस्वीरित्या "भाग्यवान" मानले जात नाही कारण त्याचे यश हे आधीच्या आयुष्यातील कलह आणि परीक्षांद्वारे दिले जाते. भविष्याच्या बाबतीत जेव्हा ते दिसते तेव्हा अनुकूल असते`,
  },
  26: {
    result: `-`,
    stars: 2.5,
    percent: 50,
    combination: `Best for Sweets ( 2 — Water {Moon} - 6 — Celebration {Venus}), Perfume, Photography, hotel, soft drink`,
    compountNumbers: `This number is full of the gravest warnings for the future. It foreshadows disasters brought about by association with others, ruin, by bad speculations, by partnerships, unions, and bad advice. If it comes out in connection with future events one should carefully consider the path one is treading`,
    compountHindi: `यह संख्या भविष्य के लिए भीषण चेतावनी से भरी है। यह आपदाओं के बारे में दूसरों के साथ मिलकर, खराब कयासों द्वारा, साझेदारी, यूनियनों और बुरी सलाह द्वारा बर्बाद कर देता है। अगर यह भविष्य की घटनाओं के सिलसिले में सामने आता है, तो किसी को सावधानी से उस मार्ग पर विचार करना चाहिए, जो फैल रहा है`,
    compoundMarathi: `ही संख्या भविष्यातील ग्रेव्हस्ट चेतावणींनी पूर्ण आहे. हे इतरांच्या संगतीमुळे, नाश, वाईट अनुमानांद्वारे, भागीदारी, संघटना आणि वाईट सल्ल्यांद्वारे आणलेल्या आपत्तींचे पूर्वचित्रण देते. जर हे भविष्यातील कार्यक्रमांच्या संबंधात उद्भवले असेल तर आपण एखाद्याने चालत असलेल्या मार्गाचा काळजीपूर्वक विचार केला पाहिजे`,
  },
  27: {
    result: `-`,
    stars: 2.5,
    percent: 50,
    combination: `Teaching / Occult. Acting, medicines, chemicals`,
    compountNumbers: `This is a good number and is symbolised as “the Sceptre”. It is a promise of authority, power, and command. It indicates that reward will come from the productive intellect, that the creative faculties have sown good seeds that will reap a harvest. Persons with this “compound” number at their back should carry out their own ideas and plans. It is a fortunate number if it appears in any connection with future events`,
    compountHindi: `यह एक अच्छी संख्या है और इसे "राजदंड" के रूप में दर्शाया गया है। यह अधिकार, शक्ति और आज्ञा का वादा है। यह इंगित करता है कि इनाम उत्पादक बुद्धि से आएगा, कि रचनात्मक संकायों ने अच्छे बीज बोए हैं जो फसल काटेंगे। अपनी पीठ पर इस "यौगिक" संख्या वाले व्यक्तियों को अपने विचारों और योजनाओं को पूरा करना चाहिए। यह भविष्य की घटनाओं के साथ किसी भी संबंध में प्रकट होने पर एक भाग्यशाली संख्या है.`,
    compoundMarathi: `ही एक चांगली संख्या आहे आणि "राजदंड" म्हणून चिन्हांकित आहे. हे अधिकार, सामर्थ्य आणि आज्ञा यांचे वचन आहे. हे सूचित करते की उत्पादक बुद्धिमत्तेद्वारे प्रतिफळ मिळेल, सर्जनशील शिक्षकांनी चांगले बियाणे पेरले आहे ज्यामुळे कापणी होईल. त्यांच्या मागच्या बाजूला हा “कंपाऊंड” नंबर असलेल्या लोकांनी स्वतःच्या कल्पना आणि योजना केल्या पाहिजेत. भविष्यातील घटनांशी संबंधित असल्यास ती एक भाग्यवान संख्या आहे`,
  },
  28: {
    result: `Avoid`,
    stars: 0.0,
    percent: 0,
    combination: `Rusted life (लोहे पे पनी), Struggie / Health issue. Real estate, Iron, electricity`,
    compountNumbers: `This number is full of contradictions. It indicates a person of great promise and possibilities who is likely to see all taken away from him unless he carefully provides for the future. It indicates loss through trust in others, opposition and competition in trade, danger of loss through law, and the likelihood of having to begin life’s road over and over again. It is not a fortunate number for the indication of future events`,
    compountHindi: `यह संख्या अंतर्विरोधों से भरी है। यह एक महान वादे और संभावनाओं के व्यक्ति को इंगित करता है जो सभी को उससे दूर ले जाने की संभावना है जब तक कि वह सावधानी से भविष्य के लिए प्रदान नहीं करता है। यह दूसरों में विश्वास के माध्यम से नुकसान, व्यापार में विरोध और प्रतिस्पर्धा, कानून के माध्यम से नुकसान का खतरा, और जीवन की सड़क को फिर से शुरू करने की संभावना दर्शाता है। यह भविष्य की घटनाओं के संकेत के लिए एक भाग्यशाली संख्या नहीं है`,
    compoundMarathi: `ही संख्या विरोधाभासांनी परिपूर्ण आहे. हे महान आश्वासनेची आणि संभाव्यतेची व्यक्ती दर्शविते जो भविष्यात काळजीपूर्वक काळजी घेतल्याशिवाय त्याच्यापासून सर्व काही काढून घेतल्याची शक्यता आहे. हे इतरांवरील विश्वासामुळे होणारा तोटा, विरोध आणि व्यापारातील स्पर्धा, कायद्याद्वारे होणारा धोका आणि पुन्हा पुन्हा जीवनाचा मार्ग सुरू होण्याची शक्यता दर्शवते. भविष्यातील घटना सूचित करण्यासाठी ही भाग्यवान संख्या नाही`,
  },
  29: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Marriage problem, Land, Police, Army, Milk items, Agriculture`,
    compountNumbers: `This number indicates uncertainties, treachery, and deception of others, it foreshadows trials, tribulation, and unexpected dangers, unreliable friends, and grief and deception caused by members of the opposite sex. It gives grave warning if it comes out in anything concerning future events`,
    compountHindi: `यह संख्या अनिश्चितताओं, विश्वासघात, और दूसरों के धोखे को इंगित करती है, यह परीक्षणों, क्लेश और अप्रत्याशित खतरों, अविश्वसनीय दोस्तों, और विपरीत लिंग के सदस्यों के कारण होने वाले दु:ख और धोखे का पूर्वाभास करती है। यदि यह भविष्य में होने वाली घटनाओं के संबंध में कुछ भी सामने आता है तो यह गंभीर चेतावनी देता है`,
    compoundMarathi: `ही संख्या अनिश्चितता, विश्वासघात आणि इतरांच्या फसवणूकीचे संकेत देते, हे परीक्षणे, क्लेश आणि अनपेक्षित धोके, अविश्वसनीय मित्र आणि विरोधाभास असलेल्या सेक्स सदस्यांमुळे उद्भवणारी दु:ख आणि फसवणूक यांचे पूर्वचित्रण करते. भविष्यात होणा काहीपण या घटनांविषयी काही त्यातून बाहेर पडल्यास गंभीर चेतावणी देते`,
  },
  30: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: `This is a number of thoughtful deduction, retrospection and mental superiority over one’s fellows, but, as it seems to belong completely to the mental plane, the persons it represents are likely to put all material things on one side -- not because they have to, but because they wish to do so. For this reason it is neither fortunate nor unfortunate, for either depends on the mental outlook of the person it represents. It can be all powerful, but it is just as often indifferent according to the will or desire of the person`,
    compountHindi: `यह एक विचारशील कटौती, पूर्वव्यापीता और मानसिक श्रेष्ठता है, जो किसी व्यक्ति के साथियों के ऊपर है, लेकिन जैसा कि यह पूरी तरह से मानसिक विमान से संबंधित है, जिन व्यक्तियों का प्रतिनिधित्व करता है, वे सभी भौतिक चीजों को एक तरफ रखने की संभावना रखते हैं - क्योंकि उन्हें शामिल नहीं करना है , लेकिन क्योंकि वे ऐसा करना चाहते हैं। इस कारण से यह न तो भाग्यशाली है और न ही दुर्भाग्यपूर्ण है, या तो यह उस व्यक्ति के मानसिक दृष्टिकोण पर निर्भर करता है जिसका वह प्रतिनिधित्व करता है। यह सब शक्तिशाली हो सकता है, लेकिन यह बस व्यक्ति की इच्छा या इच्छा के अनुसार उदासीन है`,
    compoundMarathi: `एखाद्याच्या सोबतींपेक्षा ही अनेक विवेकी कपात, पूर्वसूचना आणि मानसिक श्रेष्ठता आहे, परंतु ती पूर्णपणे मानसिक विमानाशी संबंधित असल्याचे दिसते म्हणून, ज्या व्यक्तीचे प्रतिनिधित्व करते त्यांना कदाचित सर्व भौतिक वस्तू एका बाजूला ठेवता येतील - नाही म्हणून , परंतु त्यांना अशी इच्छा आहे म्हणून. या कारणास्तव ते भाग्यवान किंवा दुर्दैवीही नाही कारण एकतर तो ज्या व्यक्तीचे प्रतिनिधित्व करतो त्याच्या मानसिक दृष्टिकोनावर अवलंबून असतो. हे सर्व सामर्थ्यवान असू शकते, परंतु एखाद्या व्यक्तीच्या इच्छेनुसार किंवा इच्छेनुसार ते नेहमीच उदासीन असते`,
  },
  31: {
    result: `-`,
    stars: 3.5,
    percent: 70,
    combination: `Occult / Education / Healer / Doctor / Administrative job, Electricity concerning, computer`,
    compountNumbers: `This number is very similar to the 30, except that the person it represents is even more self-contained, lonely, and isolated from his fellows. It is not a fortunate number from a worldly or material standpoint`,
    compountHindi: `यह संख्या 30 के समान है, सिवाय इसके कि वह जिस व्यक्ति का प्रतिनिधित्व करता है वह और भी अधिक आत्म-निहित, अकेला और अपने साथियों से अलग है। यह एक सांसारिक या भौतिक दृष्टिकोण से एक भाग्यशाली संख्या नहीं है`,
    compoundMarathi: `ही संख्या 30 प्रमाणेच आहे, शिवाय ज्या व्यक्तीचे प्रतिनिधित्व करते तो आणखी स्वयंपूर्ण, एकटेपणाचा आणि त्याच्या मित्रांपासून वेगळा असतो. सांसारिक किंवा भौतिक दृष्टिकोनातून भाग्यवान संख्या नाही`,
  },
  32: {
    result: `Very Good`,
    stars: 2.5,
    percent: 50,
    combination: `Water related work / Navy work, milk products, commotion, soft drink`,
    compountNumbers: `This number has a magical power like the single 5, or the "compound" numbers 14 and 23. It is usually associated with combinations of people or nations. It is a fortunate number if the person it represents holds to his own judgment and opinions, if not, his plans are likely to become wrecked by the stubbornness and stupidity of others. It is a favourable number if it appears in connection with future events`,
    compountHindi: `इस संख्या में एकल 5 जैसी जादुई शक्ति है, या "यौगिक" संख्या 14 और 23 है। यह आमतौर पर लोगों या राष्ट्रों के दहन के साथ जुड़ा हुआ है। यह एक सौभाग्यशाली संख्या है यदि यह व्यक्ति अपने स्वयं के निर्णय और विचारों का प्रतिनिधित्व करता है, यदि नहीं, तो उसकी योजनाओं को दूसरों की जिद और मूर्खता से बर्बाद होने की संभावना है। यह भविष्य की घटनाओं के संबंध में प्रकट होने पर एक अनुकूल संख्या है`,
    compoundMarathi: `या संख्येत एकल 5, किंवा "कंपाऊंड" क्रमांक 14 आणि 23 सारख्या जादूची शक्ती आहे. हे सहसा लोक किंवा राष्ट्रांच्या ज्वलनाशी संबंधित असते. जर ती प्रतिनिधित्त्व केलेली व्यक्ती त्याच्या स्वत: च्या निर्णयाची आणि मते धारण करीत असेल तर ही भाग्यवान संख्या आहे, जर तसे नसेल तर त्याच्या योजना इतरांच्या जिद्दीने आणि मूर्खपणामुळे खराब होऊ शकतात. भविष्यातल्या घटनांशी संबंधित असल्यास ती अनुकूल संख्या आहे`,
  },
  33: {
    result: `Excellent`,
    stars: 3.0,
    percent: 60,
    combination: `Best for education / Occult, export-import. Scientist, religious institutions head`,
    compountNumbers: `This number has no potency of its own, and consequently has the same meaning as the 24 -- which is also a 6 —- and the next to it in its own senes of "compound” numbers`,
    compountHindi: `इस संख्या की अपनी कोई शक्ति नहीं है, और फलस्वरूप इसका 24 के समान अर्थ है - जो कि 6 भी है- और इसके आगे "यौगिक" संख्याओं के अपने स्वयं के सीन्स हैं।`,
    compoundMarathi: `या संख्येचे स्वतःचे सामर्थ्य नाही आणि परिणामी 24 प्रमाणेच अर्थ आहे - जो 6% आहे - आणि त्या नंतरच्या "कंपाऊंड" संख्यांच्या स्वत: च्या सेन्समध्ये`,
  },
  34: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Good for Sales & Marketing, Judge, Publisher, social`,
    compountNumbers: `This number is full of the gravest warnings for the future. It foreshadows disasters brought about by association with others, ruin, by bad speculations, by partnerships, unions, and bad advice. If it comes out in connection with future events one should carefully consider the path one is treading`,
    compountHindi: `यह संख्या भविष्य के लिए भीषण चेतावनी से भरी है। यह आपदाओं के बारे में दूसरों के साथ मिलकर, खराब कयासों द्वारा, साझेदारी, यूनियनों और बुरी सलाह द्वारा बर्बाद कर देता है। अगर यह भविष्य की घटनाओं के सिलसिले में सामने आता है, तो किसी को सावधानी से उस मार्ग पर विचार करना चाहिए, जो फैल रहा है`,
    compoundMarathi: `ही संख्या भविष्यातील ग्रेव्हस्ट चेतावणींनी पूर्ण आहे. हे इतरांच्या संगतीमुळे, नाश, वाईट अनुमानांद्वारे, भागीदारी, संघटना आणि वाईट सल्ल्यांद्वारे आणलेल्या आपत्तींचे पूर्वचित्रण देते. जर हे भविष्यातील कार्यक्रमांच्या संबंधात उद्भवले असेल तर आपण एखाद्याने चालत असलेल्या मार्गाचा काळजीपूर्वक विचार केला पाहिजे`,
  },
  35: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Will have lot of work, Excellent communication, Anchoring, News Reading, Acting, Teaching, Banking`,
    compountNumbers: `This number is full of the gravest warnings for the future. It foreshadows disasters brought about by association with others, ruin, by bad speculations, by partnerships, unions, and bad advice. If it comes out in connection with future events one should carefully consider the path one is treading`,
    compountHindi: `यह संख्या भविष्य के लिए भीषण चेतावनी से भरी है। यह आपदाओं के बारे में दूसरों के साथ मिलकर, खराब कयासों द्वारा, साझेदारी, यूनियनों और बुरी सलाह द्वारा बर्बाद कर देता है। अगर यह भविष्य की घटनाओं के सिलसिले में सामने आता है, तो किसी को सावधानी से उस मार्ग पर विचार करना चाहिए, जो फैल रहा है`,
    compoundMarathi: `ही संख्या भविष्यातील ग्रेव्हस्ट चेतावणींनी पूर्ण आहे. हे इतरांच्या संगतीमुळे, नाश, वाईट अनुमानांद्वारे, भागीदारी, संघटना आणि वाईट सल्ल्यांद्वारे आणलेल्या आपत्तींचे पूर्वचित्रण देते. जर हे भविष्यातील कार्यक्रमांच्या संबंधात उद्भवले असेल तर आपण एखाद्याने चालत असलेल्या मार्गाचा काळजीपूर्वक विचार केला पाहिजे`,
  },
  36: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: `Struggle / Health & Marriage issues (3 & 6 are anti to each other Chattis ka aakada, But Good for business, export import of cloths)`,
    compountNumbers: `This is a good number and is symbolised as “the Sceptre”. It is a promise of authority, power, and command. It indicates that reward will come from the productive intellect, that the creative faculties have sown good seeds that will reap a harvest. Persons with this “compound” number at their back should carry out their own ideas and plans. It is a fortunate number if it appears in any connection with future events`,
    compountHindi: `यह एक अच्छी संख्या है और इसे "राजदंड" के रूप में दर्शाया गया है। यह अधिकार, शक्ति और आज्ञा का वादा है। यह इंगित करता है कि इनाम उत्पादक बुद्धि से आएगा, कि रचनात्मक संकायों ने अच्छे बीज बोए हैं जो फसल काटेंगे। अपनी पीठ पर इस "यौगिक" संख्या वाले व्यक्तियों को अपने विचारों और योजनाओं को पूरा करना चाहिए। यह भविष्य की घटनाओं के साथ किसी भी संबंध में प्रकट होने पर एक भाग्यशाली संख्या है.`,
    compoundMarathi: `ही एक चांगली संख्या आहे आणि "राजदंड" म्हणून चिन्हांकित आहे. हे अधिकार, सामर्थ्य आणि आज्ञा यांचे वचन आहे. हे सूचित करते की उत्पादक बुद्धिमत्तेद्वारे प्रतिफळ मिळेल, सर्जनशील शिक्षकांनी चांगले बियाणे पेरले आहे ज्यामुळे कापणी होईल. त्यांच्या मागच्या बाजूला हा “कंपाऊंड” नंबर असलेल्या लोकांनी स्वतःच्या कल्पना आणि योजना केल्या पाहिजेत. भविष्यातील घटनांशी संबंधित असल्यास ती एक भाग्यवान संख्या आहे`,
  },
  37: {
    result: `Excellent`,
    stars: 4.0,
    percent: 80,
    combination: `Best for education / Occult / Healing and teaching, minerals, gems, writer, speech`,
    compountNumbers: `This number has a distinct potency of its own. It is a number of good and fortunate friendship in love, and in combinations connected with the opposite sex. It is also good for partnerships of all kinds. It is a fortunate indication if it appears in connection with future events`,
    compountHindi: `इस संख्या की अपनी एक अलग क्षमता है। यह प्यार में अच्छी और भाग्यशाली दोस्ती और विपरीत लिंग के साथ जुड़े संयोजनों में से एक है। यह सभी प्रकार की साझेदारी के लिए भी अच्छा है। भविष्य में होने वाली घटनाओं के संबंध में यह एक सौभाग्यशाली संकेत है`,
    compoundMarathi: `या संख्येची स्वतःची वेगळी क्षमता आहे. हे प्रेमात आणि विरोधाभास असलेल्या जोड्यांमध्ये खूप चांगली आणि भाग्यवान मैत्री आहे. हे सर्व प्रकारच्या भागीदारीसाठी देखील चांगले आहे. भविष्यातील घटनांशी संबंधित असल्यास ती सुदैवी संकेत आहे`,
  },
  38: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Lawyer, Printing, Sales, metal, iron, heavy machinery, miner`,
    compountNumbers: `This number indicates uncertainties, treachery, and deception of others, it foreshadows trials, tribulation, and unexpected dangers, unreliable friends, and grief and deception caused by members of the opposite sex. It gives grave warning if it comes out in anything concerning future events`,
    compountHindi: `यह संख्या अनिश्चितताओं, विश्वासघात, और दूसरों के धोखे को इंगित करती है, यह परीक्षणों, क्लेश और अप्रत्याशित खतरों, अविश्वसनीय दोस्तों, और विपरीत लिंग के सदस्यों के कारण होने वाले दु:ख और धोखे का पूर्वाभास करती है। यदि यह भविष्य में होने वाली घटनाओं के संबंध में कुछ भी सामने आता है तो यह गंभीर चेतावनी देता है`,
    compoundMarathi: `ही संख्या अनिश्चितता, विश्वासघात आणि इतरांच्या फसवणूकीचे संकेत देते, हे परीक्षणे, क्लेश आणि अनपेक्षित धोके, अविश्वसनीय मित्र आणि विरोधाभास असलेल्या सेक्स सदस्यांमुळे उद्भवणारी दु:ख आणि फसवणूक यांचे पूर्वचित्रण करते. भविष्यात होणा anything्या घटनांविषयी काही त्यातून बाहेर पडल्यास गंभीर चेतावणी देते`,
  },
  39: {
    result: `OK`,
    stars: 4.0,
    percent: 80,
    combination: `Education / Occult / Army / Administrative / Doctor`,
    compountNumbers: `This is a number of thoughtful deduction, retrospection and mental superiority over one’s fellows, but, as it seems to belong completely to the mental plane, the persons it represents are likely to put all material things on one side -- not because they have to, but because they wish to do so. For this reason it is neither fortunate nor unfortunate, for either depends on the mental outlook of the person it represents. It can be all powerful, but it is just as often indifferent according to the will or desire of the person`,
    compountHindi: `यह एक विचारशील कटौती, पूर्वव्यापीता और मानसिक श्रेष्ठता है, जो किसी व्यक्ति के साथियों के ऊपर है, लेकिन जैसा कि यह पूरी तरह से मानसिक विमान से संबंधित है, जिन व्यक्तियों का प्रतिनिधित्व करता है, वे सभी भौतिक चीजों को एक तरफ रखने की संभावना रखते हैं - क्योंकि उन्हें शामिल नहीं करना है , लेकिन क्योंकि वे ऐसा करना चाहते हैं। इस कारण से यह न तो भाग्यशाली है और न ही दुर्भाग्यपूर्ण है, या तो यह उस व्यक्ति के मानसिक दृष्टिकोण पर निर्भर करता है जिसका वह प्रतिनिधित्व करता है। यह सब शक्तिशाली हो सकता है, लेकिन यह बस व्यक्ति की इच्छा या इच्छा के अनुसार उदासीन है`,
    compoundMarathi: `एखाद्याच्या सोबतींपेक्षा ही अनेक विवेकी कपात, पूर्वसूचना आणि मानसिक श्रेष्ठता आहे, परंतु ती पूर्णपणे मानसिक विमानाशी संबंधित असल्याचे दिसते म्हणून, ज्या व्यक्तीचे प्रतिनिधित्व करते त्यांना कदाचित सर्व भौतिक वस्तू एका बाजूला ठेवता येतील - नाही म्हणून , परंतु त्यांना अशी इच्छा आहे म्हणून. या कारणास्तव ते भाग्यवान किंवा दुर्दैवीही नाही कारण एकतर तो ज्या व्यक्तीचे प्रतिनिधित्व करतो त्याच्या मानसिक दृष्टिकोनावर अवलंबून असतो. हे सर्व सामर्थ्यवान असू शकते, परंतु एखाद्या व्यक्तीच्या इच्छेनुसार किंवा इच्छेनुसार ते नेहमीच उदासीन असते`,
  },
  40: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: `This number is very similar to the 30, except that the person it represents is even more self-contained, lonely, and isolated from his fellows. It is not a fortunate number from a worldly or material standpoint`,
    compountHindi: `यह संख्या 30 के समान है, सिवाय इसके कि वह जिस व्यक्ति का प्रतिनिधित्व करता है वह और भी अधिक आत्म-निहित, अकेला और अपने साथियों से अलग है। यह एक सांसारिक या भौतिक दृष्टिकोण से एक भाग्यशाली संख्या नहीं है`,
    compoundMarathi: `ही संख्या 30 प्रमाणेच आहे, शिवाय ज्या व्यक्तीचे प्रतिनिधित्व करते तो आणखी स्वयंपूर्ण, एकटेपणाचा आणि त्याच्या मित्रांपासून वेगळा असतो. सांसारिक किंवा भौतिक दृष्टिकोनातून भाग्यवान संख्या नाही`,
  },
  41: {
    result: `OK`,
    stars: 3.5,
    percent: 70,
    combination: `Politics, law, transport, Furniture, minerals`,
    compountNumbers: `This number has a magical power like the single 5, or the "compound" numbers 14 and 23. It is usually associated with combinations of people or nations. It is a fortunate number if the person it represents holds to his own judgment and opinions, if not, his plans are likely to become wrecked by the stubbornness and stupidity of others. It is a favourable number if it appears in connection with future events`,
    compountHindi: `इस संख्या में एकल 5 जैसी जादुई शक्ति है, या "यौगिक" संख्या 14 और 23 है। यह आमतौर पर लोगों या राष्ट्रों के दहन के साथ जुड़ा हुआ है। यह एक सौभाग्यशाली संख्या है यदि यह व्यक्ति अपने स्वयं के निर्णय और विचारों का प्रतिनिधित्व करता है, यदि नहीं, तो उसकी योजनाओं को दूसरों की जिद और मूर्खता से बर्बाद होने की संभावना है। यह भविष्य की घटनाओं के संबंध में प्रकट होने पर एक अनुकूल संख्या है`,
    compoundMarathi: `या संख्येत एकल 5, किंवा "कंपाऊंड" क्रमांक 14 आणि 23 सारख्या जादूची शक्ती आहे. हे सहसा लोक किंवा राष्ट्रांच्या ज्वलनाशी संबंधित असते. जर ती प्रतिनिधित्त्व केलेली व्यक्ती त्याच्या स्वत: च्या निर्णयाची आणि मते धारण करीत असेल तर ही भाग्यवान संख्या आहे, जर तसे नसेल तर त्याच्या योजना इतरांच्या जिद्दीने आणि मूर्खपणामुळे खराब होऊ शकतात. भविष्यातल्या घटनांशी संबंधित असल्यास ती अनुकूल संख्या आहे`,
  },
  42: {
    result: `Avoid`,
    stars: 2.0,
    percent: 40,
    combination: `Depression / Struggle whole life, Law, water, transport, electricity, soft drink, Religion`,
    compountNumbers: `This number is also fortunate; it promises the assistance and association of those of rank and position with one’s plans, it also denotes gain through love and the opposite sex, it is a favourable number when it comes out in relation to future events`,
    compountHindi: `यह संख्या भी सौभाग्यशाली है; यह एक योजना के साथ रैंक और स्थिति वाले लोगों की सहायता और सहयोग का वादा करता है, यह प्रेम और विपरीत लिंग के माध्यम से लाभ को भी दर्शाता है, भविष्य की घटनाओं के संबंध में यह एक अनुकूल संख्या है।`,
    compoundMarathi: `ही संख्या देखील भाग्यवान आहे; हे एखाद्याच्या योजनांसह पद आणि स्थान असलेल्यांच्या सहकार्याची आणि संबद्धतेची प्रतिज्ञा करते, हे प्रेम आणि उलट लैंगिकतेद्वारे मिळवलेले अर्थ देखील दर्शवते, जेव्हा भविष्यातील घटनांच्या संबंधात ही एक चांगली संख्या असते तेव्हा`,
  },
  43: {
    result: `-`,
    stars: 2.5,
    percent: 50,
    combination: `Sales & Marketing / Occult education, Govt job, hotel, law, hotel`,
    compountNumbers: `This is an unfortunate number. It is symbolised by the signs of revolution, upheaval, strife, failure, and prevention, and is not a fortunate number if it comes out in calculations relating to future events.`,
    compountHindi: `यह एक दुर्भाग्यपूर्ण संख्या है। यह क्रांति, उथल-पुथल, संघर्ष, विफलता और रोकथाम के संकेतों का प्रतीक है, और भविष्य की घटनाओं से संबंधित गणनाओं में सामने आने पर यह एक भाग्यशाली संख्या नहीं है।`,
    compoundMarathi: `ही दुर्दैवी संख्या आहे. हे क्रांती, उलथापालथ, कलह, अपयश आणि प्रतिबंध या चिन्हे दर्शवितात आणि भविष्यातील घटनांशी संबंधित गणिते आल्यास ते भाग्यवान नाही.`,
  },
  44: {
    result: `-`,
    stars: 1.5,
    percent: 30,
    combination: `Best for Law / Struggle, commission, transport, gas, chemicals, export-import, Petrol-diesel, chemicals, writer, poet`,
    compountNumbers: `This number is full of the gravest warnings for the future. It foreshadows disasters brought about by association with others, ruin, by bad speculations, by partnerships, unions, and bad advice. If it comes out in connection with future events one should carefully consider the path one is treading`,
    compountHindi: `यह संख्या भविष्य के लिए भीषण चेतावनी से भरी है। यह आपदाओं के बारे में दूसरों के साथ मिलकर, खराब कयासों द्वारा, साझेदारी, यूनियनों और बुरी सलाह द्वारा बर्बाद कर देता है। अगर यह भविष्य की घटनाओं के सिलसिले में सामने आता है, तो किसी को सावधानी से उस मार्ग पर विचार करना चाहिए, जो फैल रहा है`,
    compoundMarathi: `ही संख्या भविष्यातील ग्रेव्हस्ट चेतावणींनी पूर्ण आहे. हे इतरांच्या संगतीमुळे, नाश, वाईट अनुमानांद्वारे, भागीदारी, संघटना आणि वाईट सल्ल्यांद्वारे आणलेल्या आपत्तींचे पूर्वचित्रण देते. जर हे भविष्यातील कार्यक्रमांच्या संबंधात उद्भवले असेल तर आपण एखाद्याने चालत असलेल्या मार्गाचा काळजीपूर्वक विचार केला पाहिजे`,
  },
  45: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Banking / Event managment, gas, chemicals`,
    compountNumbers: `This is a good number and is symbolised as “the Sceptre”. It is a promise of authority, power, and command. It indicates that reward will come from the productive intellect, that the creative faculties have sown good seeds that will reap a harvest. Persons with this “compound” number at their back should carry out their own ideas and plans. It is a fortunate number if it appears in any connection with future events`,
    compountHindi: `यह एक अच्छी संख्या है और इसे "राजदंड" के रूप में दर्शाया गया है। यह अधिकार, शक्ति और आज्ञा का वादा है। यह इंगित करता है कि इनाम उत्पादक बुद्धि से आएगा, कि रचनात्मक संकायों ने अच्छे बीज बोए हैं जो फसल काटेंगे। अपनी पीठ पर इस "यौगिक" संख्या वाले व्यक्तियों को अपने विचारों और योजनाओं को पूरा करना चाहिए। यह भविष्य की घटनाओं के साथ किसी भी संबंध में प्रकट होने पर एक भाग्यशाली संख्या है.`,
    compoundMarathi: `ही एक चांगली संख्या आहे आणि "राजदंड" म्हणून चिन्हांकित आहे. हे अधिकार, सामर्थ्य आणि आज्ञा यांचे वचन आहे. हे सूचित करते की उत्पादक बुद्धिमत्तेद्वारे प्रतिफळ मिळेल, सर्जनशील शिक्षकांनी चांगले बियाणे पेरले आहे ज्यामुळे कापणी होईल. त्यांच्या मागच्या बाजूला हा “कंपाऊंड” नंबर असलेल्या लोकांनी स्वतःच्या कल्पना आणि योजना केल्या पाहिजेत. भविष्यातील घटनांशी संबंधित असल्यास ती एक भाग्यवान संख्या आहे`,
  },
  46: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Media / luxury / Glamour. Perfumes, art, acting`,
    compountNumbers: `This number has a distinct potency of its own. It is a number of good and fortunate friendship in love, and in combinations connected with the opposite sex. It is also good for partnerships of all kinds. It is a fortunate indication if it appears in connection with future events`,
    compountHindi: `इस संख्या की अपनी एक अलग क्षमता है। यह प्यार में अच्छी और भाग्यशाली दोस्ती और विपरीत लिंग के साथ जुड़े संयोजनों में से एक है। यह सभी प्रकार की साझेदारी के लिए भी अच्छा है। भविष्य में होने वाली घटनाओं के संबंध में यह एक सौभाग्यशाली संकेत है`,
    compoundMarathi: `या संख्येची स्वतःची वेगळी क्षमता आहे. हे प्रेमात आणि विरोधाभास असलेल्या जोड्यांमध्ये खूप चांगली आणि भाग्यवान मैत्री आहे. हे सर्व प्रकारच्या भागीदारीसाठी देखील चांगले आहे. भविष्यातील घटनांशी संबंधित असल्यास ती सुदैवी संकेत आहे`,
  },
  47: {
    result: `-`,
    stars: 4.0,
    percent: 80,
    combination: `Rahu-Ketu, Successful / Best in Occult, Games, Medicines, Import, Writer`,
    compountNumbers: `This number indicates uncertainties, treachery, and deception of others, it foreshadows trials, tribulation, and unexpected dangers, unreliable friends, and grief and deception caused by members of the opposite sex. It gives grave warning if it comes out in anything concerning future events`,
    compountHindi: `यह संख्या अनिश्चितताओं, विश्वासघात, और दूसरों के धोखे को इंगित करती है, यह परीक्षणों, क्लेश और अप्रत्याशित खतरों, अविश्वसनीय दोस्तों, और विपरीत लिंग के सदस्यों के कारण होने वाले दु:ख और धोखे का पूर्वाभास करती है। यदि यह भविष्य में होने वाली घटनाओं के संबंध में कुछ भी सामने आता है तो यह गंभीर चेतावनी देता है`,
    compoundMarathi: `ही संख्या अनिश्चितता, विश्वासघात आणि इतरांच्या फसवणूकीचे संकेत देते, हे परीक्षणे, क्लेश आणि अनपेक्षित धोके, अविश्वसनीय मित्र आणि विरोधाभास असलेल्या सेक्स सदस्यांमुळे उद्भवणारी दु:ख आणि फसवणूक यांचे पूर्वचित्रण करते. भविष्यात होणा anything्या घटनांविषयी काही त्यातून बाहेर पडल्यास गंभीर चेतावणी देते`,
  },
  48: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Struggle / excellent for Law / machinery, import, printing, computer, medicines`,
    compountNumbers: `This is a number of thoughtful deduction, retrospection and mental superiority over one’s fellows, but, as it seems to belong completely to the mental plane, the persons it represents are likely to put all material things on one side -- not because they have to, but because they wish to do so. For this reason it is neither fortunate nor unfortunate, for either depends on the mental outlook of the person it represents. It can be all powerful, but it is just as often indifferent according to the will or desire of the person`,
    compountHindi: `यह एक विचारशील कटौती, पूर्वव्यापीता और मानसिक श्रेष्ठता है, जो किसी व्यक्ति के साथियों के ऊपर है, लेकिन जैसा कि यह पूरी तरह से मानसिक विमान से संबंधित है, जिन व्यक्तियों का प्रतिनिधित्व करता है, वे सभी भौतिक चीजों को एक तरफ रखने की संभावना रखते हैं - क्योंकि उन्हें शामिल नहीं करना है , लेकिन क्योंकि वे ऐसा करना चाहते हैं। इस कारण से यह न तो भाग्यशाली है और न ही दुर्भाग्यपूर्ण है, या तो यह उस व्यक्ति के मानसिक दृष्टिकोण पर निर्भर करता है जिसका वह प्रतिनिधित्व करता है। यह सब शक्तिशाली हो सकता है, लेकिन यह बस व्यक्ति की इच्छा या इच्छा के अनुसार उदासीन है`,
    compoundMarathi: `एखाद्याच्या सोबतींपेक्षा ही अनेक विवेकी कपात, पूर्वसूचना आणि मानसिक श्रेष्ठता आहे, परंतु ती पूर्णपणे मानसिक विमानाशी संबंधित असल्याचे दिसते म्हणून, ज्या व्यक्तीचे प्रतिनिधित्व करते त्यांना कदाचित सर्व भौतिक वस्तू एका बाजूला ठेवता येतील - नाही म्हणून , परंतु त्यांना अशी इच्छा आहे म्हणून. या कारणास्तव ते भाग्यवान किंवा दुर्दैवीही नाही कारण एकतर तो ज्या व्यक्तीचे प्रतिनिधित्व करतो त्याच्या मानसिक दृष्टिकोनावर अवलंबून असतो. हे सर्व सामर्थ्यवान असू शकते, परंतु एखाद्या व्यक्तीच्या इच्छेनुसार किंवा इच्छेनुसार ते नेहमीच उदासीन असते`,
  },
  49: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Struggle / Health / Probems / Surgeries / Accidents`,
    compountNumbers: `This number is very similar to the 30, except that the person it represents is even more self-contained, lonely, and isolated from his fellows. It is not a fortunate number from a worldly or material standpoint`,
    compountHindi: `यह संख्या 30 के समान है, सिवाय इसके कि वह जिस व्यक्ति का प्रतिनिधित्व करता है वह और भी अधिक आत्म-निहित, अकेला और अपने साथियों से अलग है। यह एक सांसारिक या भौतिक दृष्टिकोण से एक भाग्यशाली संख्या नहीं है`,
    compoundMarathi: `ही संख्या 30 प्रमाणेच आहे, शिवाय ज्या व्यक्तीचे प्रतिनिधित्व करते तो आणखी स्वयंपूर्ण, एकटेपणाचा आणि त्याच्या मित्रांपासून वेगळा असतो. सांसारिक किंवा भौतिक दृष्टिकोनातून भाग्यवान संख्या नाही`,
  },
  50: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: `This number has a magical power like the single 5, or the "compound" numbers 14 and 23. It is usually associated with combinations of people or nations. It is a fortunate number if the person it represents holds to his own judgment and opinions, if not, his plans are likely to become wrecked by the stubbornness and stupidity of others. It is a favourable number if it appears in connection with future events`,
    compountHindi: `इस संख्या में एकल 5 जैसी जादुई शक्ति है, या "यौगिक" संख्या 14 और 23 है। यह आमतौर पर लोगों या राष्ट्रों के दहन के साथ जुड़ा हुआ है। यह एक सौभाग्यशाली संख्या है यदि यह व्यक्ति अपने स्वयं के निर्णय और विचारों का प्रतिनिधित्व करता है, यदि नहीं, तो उसकी योजनाओं को दूसरों की जिद और मूर्खता से बर्बाद होने की संभावना है। यह भविष्य की घटनाओं के संबंध में प्रकट होने पर एक अनुकूल संख्या है`,
    compoundMarathi: `या संख्येत एकल 5, किंवा "कंपाऊंड" क्रमांक 14 आणि 23 सारख्या जादूची शक्ती आहे. हे सहसा लोक किंवा राष्ट्रांच्या ज्वलनाशी संबंधित असते. जर ती प्रतिनिधित्त्व केलेली व्यक्ती त्याच्या स्वत: च्या निर्णयाची आणि मते धारण करीत असेल तर ही भाग्यवान संख्या आहे, जर तसे नसेल तर त्याच्या योजना इतरांच्या जिद्दीने आणि मूर्खपणामुळे खराब होऊ शकतात. भविष्यातल्या घटनांशी संबंधित असल्यास ती अनुकूल संख्या आहे`,
  },
  51: {
    result: `Excellent`,
    stars: 4.0,
    percent: 80,
    combination: `Successful / Finance / Loan / Property / Art / Drama, Computer, Electronics, Spare parts, Writer (Balanced Life)`,
    compountNumbers: `This number has a very powerful potency of its own. It represents the nature of the warrior, it promises sudden advancement in whatever one undertakes, it is especially favourable for those in military or naval life and for leaders in any cause. At the same time it threatens enemies, danger, and the likehhood of assassination`,
    compountHindi: `इस संख्या की अपनी खुद की एक बहुत शक्तिशाली क्षमता है। यह योद्धा की प्रकृति का प्रतिनिधित्व करता है, यह किसी भी एक उपक्रम में अचानक उन्नति का वादा करता है, यह विशेष रूप से सैन्य या नौसेना जीवन में और किसी भी कारण से नेताओं के लिए अनुकूल है। एक ही समय में यह दुश्मनों, खतरे और हत्या की आशंका की धमकी देता है`,
    compoundMarathi: `या नंबरची स्वतःची एक सामर्थ्यवान क्षमता आहे. हे योद्धाच्या स्वरूपाचे प्रतिनिधित्व करते, जे काही हाती घेतो त्यात अचानक प्रगती करण्याचे आश्वासन दिले जाते, हे विशेषतः सैन्य किंवा नौदल जीवनासाठी आणि कोणत्याही कारणास्तव नेत्यांसाठी अनुकूल असते. त्याच वेळी हे शत्रूंना, धोक्यात आणि खुनास सामर्थ्य निर्माण करते`,
  },
  52: {
    result: `OK`,
    stars: 3.5,
    percent: 70,
    combination: `Property line, Own home, multiple property, electronics, commission, fashion, jewelry, cloth export, import`,
    compountNumbers: `This is an unfortunate number. It is symbolised by the signs of revolution, upheaval, strife, failure, and prevention, and is not a fortunate number if it comes out in calculations relating to future events.`,
    compountHindi: `यह एक दुर्भाग्यपूर्ण संख्या है। यह क्रांति, उथल-पुथल, संघर्ष, विफलता और रोकथाम के संकेतों का प्रतीक है, और भविष्य की घटनाओं से संबंधित गणनाओं में सामने आने पर यह एक भाग्यशाली संख्या नहीं है।`,
    compoundMarathi: `ही दुर्दैवी संख्या आहे. हे क्रांती, उलथापालथ, कलह, अपयश आणि प्रतिबंध या चिन्हे दर्शवितात आणि भविष्यातील घटनांशी संबंधित गणिते आल्यास ते भाग्यवान नाही.`,
  },
  53: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Communication / Occult, Fabric, commission, Public transport`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  54: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Overall successful / Sales & Marketing, machinery, Fire, import export`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  55: {
    result: `Very Good +`,
    stars: 4.0,
    percent: 80,
    combination: `Very Successful, Romantic {May Be Lazy}, art, writer, commission, machine manufacture, astrology`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  56: {
    result: `-`,
    stars: 4.5,
    percent: 90,
    combination: `Life is successful, media,Hotel, Pub,auto mobile, chemical, fashion`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  57: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Occult & Banking, Computer, writer, speaker religous, minerals, commission`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  58: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Good, Property real estate, iron, machinery, silver business, labour`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  59: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Successful, Banking, Trading, army, Administration, metal, import export, lawyer, politics`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  60: {
    result: `OK`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  61: {
    result: `OK`,
    stars: 3.5,
    percent: 70,
    combination: `Media / luxury / Glamour, Politics, Restaurant, Hotel, Gems, Cloths, Solar power, Jewellery`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  62: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Sweet shop, Sweet business, Liquor, Chemicals, Gems`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  63: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: `Health & Marriage issues, Worst Combination, Health??, Marriage ??, Writer, Cloths, Computer, Politics`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  64: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Successful / Media, Law, Glamor, medicines, import-export, gems, cloths`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  65: {
    result: `-`,
    stars: 4.5,
    percent: 90,
    combination: `Super successful, Luxury, gold, Computer, Cloths`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  66: {
    result: `Excellent (Guru Guru)`,
    stars: 4.0,
    percent: 80,
    combination: `Super successful in: media / Film industry / Tour & Travel, cloths`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  67: {
    result: `-`,
    stars: 3.5,
    percent: 70,
    combination: `Successful, Sports, Romantic, Art, Speaker, Medicines, Agriculture`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  68: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Best for Law, Iron, Machinery, Coal, Automobile`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  69: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Successful but Marriage problem. Scandles, Controversies, Commission, Transport, Army, Police`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  70: {
    result: `Can Go`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  71: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Best for occult, Cloths, Electricity, Medicines, Computer, Perfumes`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  72: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Intuitive / Occult, Writer, Speaker, Water, Lonely, Agriculture, Architecture, Poet, Painting`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  73: {
    result: `Excellent`,
    stars: 3.0,
    percent: 60,
    combination: `Teaching / Healing / Occult, IAS, Administration`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  74: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Successful combination, Cinema, Transport, Publish`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  75: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Occult, Sitting job, Laptop, Graphic, Banking`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  76: {
    result: `-`,
    stars: 4.0,
    percent: 80,
    combination: `Sports (Mahinder singh Dhoni), Occult science`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  77: {
    result: `OK`,
    stars: 1.0,
    percent: 20,
    combination: `(धोखा,धोखा,धोखा), Disappointment in life / Marriage life in danger, Phobia / Astrology, Occult, Religious, Law, Iron, Computer, Medicines, Electronics`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  78: {
    result: `OK`,
    stars: 1.0,
    percent: 20,
    combination: `Struggle in life, Occult science, Vastu, Teaching`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  79: {
    result: `Can Go`,
    stars: 1.0,
    percent: 20,
    combination: `Teaching / Occult, Healing, Army, Eating joint`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  80: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  81: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: `Struggie, Marriage Problem whole life, Police admin, Law, Engineer`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  82: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: `(लोहे पे पानी - झङ्ग्), Rusted life, Health issue / Struggle, Engineer, Hotel, Farming, Printing`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  83: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Knowledge, Law, Property, Occult, Teaching, Printing press, Lawyer, Engineer, Iron`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  84: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Best Law, Sales & marketing, But struggle in life, Export import, Heavy industry, Marketing`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  85: {
    result: `-`,
    stars: 3.0,
    percent: 60,
    combination: `Successful, Law, Real estate, Property, Show business, Leather business, Iron, Machinery, Teacher, Doctor, Surgen`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  86: {
    result: `Can Go`,
    stars: 3.0,
    percent: 60,
    combination: `Best for law, Iron, Cloths, Auto mobile`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  87: {
    result: `OK`,
    stars: 2.0,
    percent: 40,
    combination: `Best for Occult, Healing, Teaching, Lawyer, Professor, Painter, Chemical`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  88: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Struggle but good in Sports, Show business, Leather business, Physical labor`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  89: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Army (8 – Satrun represents physical efforts), Real estate, Printing press, Leather, Machinery, Surgen, Police, Arms, Politics`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  90: {
    result: `-`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  91: {
    result: `Excellent`,
    stars: 4.0,
    percent: 80,
    combination: `Successful, Army is best, Encounter specialist, IAS, IPS, Police, Arms`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  92: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Struggle, Marriage Problem, Liquor, Agriculture, Hotel, Import export`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  93: {
    result: `OK`,
    stars: 2.5,
    percent: 50,
    combination: `Occult / Healing, IAS, Administration job, Army, Police, Surgeon`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  94: {
    result: `-`,
    stars: 1.5,
    percent: 30,
    combination: `Struggle, Surgeries, Health issues, Army, Police, Fire arms`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  95: {
    result: `OK`,
    stars: 3.0,
    percent: 60,
    combination: `Successful - Doctor, Engineer, Teacher, Propert dealer, Politics`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  96: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Scandals / Controversies, (नेकी कर जुते खा), Shipping, Luxury goods, Fashion designer`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  97: {
    result: `Can Go`,
    stars: 1.0,
    percent: 20,
    combination: `Occult / Teaching, Healing, Law, Teacher, Electricity, Writer`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  98: {
    result: `-`,
    stars: 2.0,
    percent: 40,
    combination: `Army / Police, Iron, Leather, Fuel`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  99: {
    result: `-`,
    stars: 1.0,
    percent: 20,
    combination: `Marriage problem ?, Hate Sexual Life, Police army, Electricity, Fire`,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
  100: {
    result: `Very Good`,
    stars: 0.0,
    percent: 0,
    combination: ``,
    compountNumbers: ``,
    compountHindi: ``,
    compoundMarathi: ``,
  },
});
